import { useEffect, useRef, useState } from "react";
import * as S from "./styles.ts";

export const InfoPopup = ({ info }) => {
  const [showInfo, setShowInfo] = useState(false);

  const textRef = useRef<HTMLParagraphElement>(null);
  const iconRef = useRef<HTMLButtonElement>(null);

  function hide() {
    setShowInfo(false);
  }

  useEffect(() => {
    if (textRef.current && iconRef.current) {
      const iconPos = iconRef.current.getBoundingClientRect();
      textRef.current.style.left = `${iconPos.left + 20}px`;
      textRef.current.style.top = `${iconPos.top - 10}px`;
    }
    if (showInfo) {
      window.addEventListener("scroll", hide, true);

      return () => {
        window.removeEventListener("scroll", hide, true);
      };
    }
  }, [showInfo]);

  return (
    <S.InfoPopupPositionContainer>
      <S.InfoPopupContainer>
        <S.InfoPopupIcon
          ref={iconRef}
          onMouseEnter={() => setShowInfo(true)}
          onMouseLeave={() => setShowInfo(false)}
        >
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11ZM6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12Z"
              fill={"#ea1b4b"}
            />
            <path
              d="M6.4 7.4254H5.36279C5.36589 7.13374 5.3907 6.88911 5.43721 6.69153C5.48372 6.49082 5.56124 6.30892 5.66977 6.14583C5.7814 5.98275 5.92868 5.81026 6.11163 5.62836C6.25426 5.49037 6.38295 5.36022 6.49767 5.2379C6.6124 5.11246 6.70388 4.98073 6.77209 4.84274C6.84031 4.70161 6.87442 4.5401 6.87442 4.3582C6.87442 4.16062 6.84186 3.99283 6.77674 3.85484C6.71163 3.71685 6.6155 3.61178 6.48837 3.53965C6.36434 3.46752 6.2093 3.43145 6.02326 3.43145C5.86822 3.43145 5.72248 3.46281 5.58605 3.52554C5.44961 3.58513 5.33953 3.67921 5.25581 3.8078C5.17209 3.93324 5.12713 4.09946 5.12093 4.30645H4C4.0062 3.91129 4.09922 3.57885 4.27907 3.30914C4.45891 3.03943 4.70078 2.83714 5.00465 2.70228C5.30853 2.56743 5.64806 2.5 6.02326 2.5C6.43876 2.5 6.7938 2.57213 7.08837 2.7164C7.38295 2.85753 7.60775 3.06452 7.76279 3.33737C7.92093 3.60708 8 3.93324 8 4.31586C8 4.59185 7.94574 4.84274 7.83721 5.06855C7.72868 5.29122 7.5876 5.49978 7.41395 5.69422C7.24031 5.88553 7.05271 6.07684 6.85116 6.26815C6.67752 6.42809 6.55969 6.60215 6.49767 6.79032C6.43566 6.97536 6.4031 7.18705 6.4 7.4254ZM5.26977 8.89315C5.26977 8.72379 5.32713 8.58109 5.44186 8.46505C5.55659 8.34588 5.71318 8.28629 5.91163 8.28629C6.11008 8.28629 6.26667 8.34588 6.3814 8.46505C6.49612 8.58109 6.55349 8.72379 6.55349 8.89315C6.55349 9.0625 6.49612 9.20677 6.3814 9.32594C6.26667 9.44198 6.11008 9.5 5.91163 9.5C5.71318 9.5 5.55659 9.44198 5.44186 9.32594C5.32713 9.20677 5.26977 9.0625 5.26977 8.89315Z"
              fill={"#ea1b4b"}
            />
          </svg>
        </S.InfoPopupIcon>
        {showInfo && (
          <S.InfoPopupText
            ref={textRef}
            dangerouslySetInnerHTML={{ __html: info }}
          />
        )}
      </S.InfoPopupContainer>
    </S.InfoPopupPositionContainer>
  );
};

export default InfoPopup;
